/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar-check-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2m0 16H5V10h14v10M5 8V6h14v2H5m5.56 10.46l5.94-5.93-1.07-1.06-4.87 4.87-2.11-2.11-1.06 1.06 3.17 3.17z"/>'
  }
})
